// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oEB7","delete":"styles_delete__3u4Rq","update":"styles_update__3JPl7","add":"styles_add__3GpFR"};